<template>
  <div class="inner-box">
    <el-form size="mini" :model="form" ref="agentInfoForm" class="components">

      <el-row>
        <el-col>
          <el-col :span="8">
            <el-form-item label="센터ID">
              <el-input v-model="form.asAgentCd"></el-input>
              <el-input v-model="form.asAgentId" v-show='false'></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="센터명" prop="catNm">
              <el-input v-model="form.asAgentNm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="대표자명" prop="catNm">
              <el-input v-model="form.keyManNm"></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="4">
            <el-form-item label="사업장주소">
                <el-input v-model="form.zipCd" style="width: 80%"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="addrOpenPopUp"></el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <el-input v-model="form.addr1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <el-input v-model="form.addr2"></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="8">
            <el-form-item label="사업장명">
              <el-input v-model="form.asAgentFullNm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="사업자번호">
              <el-input v-model="form.businessNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="사업자구분">
              <el-input v-model="form.businessType"></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="8">
            <el-form-item label="업종">
              <el-input v-model="form.territory"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="업태">
              <el-input v-model="form.businessStatus"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="지역">
              <el-select v-model="form.area">
                <el-option value=''  label="전체">전체</el-option>
                <el-option
                  v-for="item in combos['areaAgent']"
                  :key="item.key"
                  :value="item.key"
                  :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="8">
            <el-form-item label="대표전화번호">
              <el-input v-model="form.telNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="핸드폰">
              <el-input v-model="form.hpNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="E-Mail">
              <el-input v-model="form.email"></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="16">
            <el-form-item label="담당지역">
              <el-input v-model="form.description"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="센터구분">
              <el-select v-model="form.asAgentType">
                <el-option value=''  label="전체">전체</el-option>
                <el-option
                  v-for="item in combos['asAgentType']"
                  :key="item.key"
                  :value="item.key"
                  :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="8">
            <el-form-item label="이행보증보험">
              <el-input v-model="form.guaranteeInsurance"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="계약기간">
              <el-date-picker type="date" placeholder="Pick a date" v-model="form.contractStartDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="　">
              <el-date-picker type="date" placeholder="Pick a date" v-model="form.contractEndDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="계약상태">
              <el-select v-model="form.contractStatus">
                <el-option value=''  label="">전체</el-option>
                <el-option
                  v-for="item in combos['contractStatus']"
                  :key="item.key"
                  :value="item.key"
                  :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
          <el-col :span="6">
            <el-form-item label="대체센터">
              <el-select v-model="form.subArea" @change="onCatIdChange">
                <el-option value='' label="전체">==전체==</el-option>
                <el-option
                    v-for="item in combos['SubAreaAgent']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
          <el-form-item label="　">
              <el-select v-model="form.subAsAgentId" v-if="form.subArea != ''">
                <el-option value='' label="선택">선택</el-option>
                <el-option
                    v-for="item in combos['SubAreaAgentDetail']"
                    :key="item.key"
                    :value="parseInt(item.key)"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
      </el-row>

    </el-form>
  </div>

</template>

<script>
import _ from "lodash";

export default {
  name: "AgentInfo",
  props: ['custParam'],
  data() {
    return {
      form: {
        addr1:"",
        addr2:"",
        area:"",
        subArea:"",
        asAgentFullNm:"",
        asAgentId:"",
        asAgentNm:"",
        asAgentType:"",
        subAsAgentId:"",
        businessNo:"",
        businessStatus:"",
        businessType:"",
        companyId:"",
        contractEndDt:"",
        contractStartDt:"",
        contractStatus:"",
        createDt:"",
        creatorId:"",
        creatorNm:"",
        deleteYn:"",
        description:"",
        email:"",
        friAfterNoonYn:"",
        friMorningYn:"",
        guaranteeInsurance:"",
        hpNo:"",
        keyManNm:"",
        monAfterNoonYn:"",
        monMorningYn:"",
        satAfterNoonYn:"",
        satMorningYn:"",
        sunAfterNoonYn:"",
        sunMorningYn:"",
        telNo:"",
        territory:"",
        thuAfterNoonYn:"",
        thuMorningYn:"",
        tueAfterNoonYn:"",
        tueMorningYn:"",
        updateDt:"",
        updatorId:"",
        updatorNm:"",
        wedAfterNoonYn:"",
        wedMorningYn:"",
        zipCd:"",
      },
      combos: {
        'asAgentType' : [],           //센터구분
        'areaAgent' : [],             //지역구분
        'contractStatus' : [],        //계약상태
        'SubAreaAgent' : [],        //지역구분
        'SubAreaAgentDetail' : [],        //센터
      },
      // eslint-disable-next-line vue/no-dupe-keys
      tapName: "default",
    };
  },
  methods: {
    setInfo() {
      this.form.subArea = "";
      Object.assign(this.form, this.custParam);
      Object.assign(this.combos, this.combo);
      this.setCatIdAndSubCatId(this.form.subAsAgentId);
      this.$forceUpdate();
    },
    defaultInfo(){
      this.tapName = "default";
    },
    agentInfo(){
      this.tapName = "agent";
    },
    timeTableInfo(){
      this.tapName = "time";
    },
    onCatIdChange(param){
      this.form.subAsAgentId = null;
      // 지역 상세
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: param} })
          .then(response => {
            this.combos['SubAreaAgentDetail'] = response.data || []
            this.$forceUpdate();
          }).finally(() => {
      });
    },
    setCatIdAndSubCatId(param){
      let valueSubCatId;
      this.$http.get(`/api/codeMng/detail/catId`, { params: {catId: param}})
          .then(response => {
            // 조회 한 지역/센터 값
            valueSubCatId = response.data;
            // 지역 값 선택
            this.form.subArea  = _.cloneDeep(this.combos['SubAreaAgent'].filter(x => parseInt(x.key) === valueSubCatId[0].parentId)[0].key)
            // 지역 상세값 리스트 조회
            // this.$http.get(`/api/codeMng/combo`, { params: {parentId: valueSubCatId[0].parentId} }).then(response => {
            //   this.combos['SubAreaAgent'] = response.data || []
              // 지역 상세값 선택
              // this.form.asAgentId  = _.cloneDeep(this.combos['SubAreaAgentDetail'].filter(x => x.key === valueSubCatId[0].catKey)[0].key)
            })
          // })
    },
    deleteButton(){

    },
    saveButton(){

    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/asAgentMng/init`)
        .then(response => {
          this.combos['asAgentType'] = response.data.asAgentType;        //센터구분
          this.combos['areaAgent'] = response.data.areaAgent2;            //지역구분
          this.combos['contractStatus'] = response.data.contractStatus;  //계약상태
        }).finally(() => {
          //this.goOpen();
          this.$store.commit('finish');
          this.init2();
        });
    },
    async init2() {
      this.$store.commit('loading');
      await this.$http.post(`/api/asAgentMng/init2`,{
        parentId: this.form.subArea
      })
          .then(response => {
            this.combos['SubAreaAgent'] = response.data.subAreaAgent;        //센터구분
            this.combos['SubAreaAgentDetail'] = response.data.subAreaAgentDetail;            //지역구분
          }).finally(() => {
            //this.goOpen();
            this.$forceUpdate();
            this.$store.commit('finish');
          });
    },
    addrOpenPopUp() {
      const vm = this;
      // eslint-disable-next-line no-undef
      new daum.Postcode({
        oncomplete: (data) => {
          var fullAddr = data.address; //최종 주소 변수
          var extraAddr = ''; // 조합형 주소 변수

          if(data.userSelectedType === 'R') {
            if(data.bname) {
              extraAddr += data.bname;
            }
            if(data.buildingName) {
              extraAddr += (extraAddr ? ', '+ data.buildingName : data.buildingName);
            }
            fullAddr += (extraAddr ? ' ('+ extraAddr + ')' : '');
          } else {
              fullAddr = data.jibunAddress;
          }
          
          vm.form.zipCd = data.zonecode;
          vm.form.addr1 = fullAddr;
          vm.form.addr2 = ''; // 초기화
        }
      }).open();
    }
  },
  created() {
    this.init();
  },
  watch: {
    custParam() {
      this.setInfo();
    },
    selectId(){
      this.setInfo();
    },
    'form.subArea'() {
      this.init2();
    },
  }
}

</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 0;
  // &:last-child {
  //   margin-bottom: 0;
  // }
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px 0 0 10px;
  border-radius: 5px;
}
.el-form-item {
  margin-right: 10px;
  // &:last-child {
  //   margin-right: 0;
  // }
}
.large-textarea{
  padding: 0 24px !important
}
.el-select {
  width: 100%;
}
</style>